import {
  CheckCircleFilled,
  CloseCircleFilled,
  WarningOutlined,
} from '@ant-design/icons'
import { Card, Col, Flex, Layout, Row, Typography, theme } from 'antd'
import React from 'react'
import { useTenant } from './contexts/tenant/TenantContext'

const { Text, Title } = Typography
const { Content } = Layout
const { useToken } = theme

interface Props {
  children: React.ReactNode
}

export const SuspendedModal = ({ children }: Props) => {
  const { tenant } = useTenant()
  const { token } = useToken()

  if (tenant.status === 'suspended') {
    return (
      <Layout>
        <Content>
          <Row
            align="middle"
            style={{ minHeight: '100vh', margin: 0, textAlign: 'center' }}
          >
            <Col xs={22} sm={16} md={10} lg={7} style={{ margin: '0 auto' }}>
              <Flex vertical gap={20} align="center">
                <WarningOutlined
                  style={{ fontSize: 48, color: token.colorError }}
                />
                <Flex vertical gap={6}>
                  <Title
                    level={3}
                    style={{ margin: 0, color: token.colorError }}
                  >
                    Access suspended
                  </Title>
                  <Text type="danger" strong>
                    Back-office access has been suspended due to an outstanding
                    payment.
                  </Text>
                  <Text type="danger" strong>
                    Please contact your organization admin to resolve this
                    issue.
                  </Text>
                </Flex>

                <Card>
                  <Flex vertical gap={8} style={{ textAlign: 'left' }}>
                    <Flex gap={8} align="flex-start">
                      <CloseCircleFilled
                        style={{ color: token.colorError, marginTop: 3 }}
                      />
                      <Text>Back office</Text>
                    </Flex>
                    {[
                      'Mobile app, table & event bookings still available',
                      'WhatsApp bot reservations still operational',
                      'Membership sign-ups & payments still functional',
                    ].map((item) => (
                      <Flex key={item} gap={8} align="flex-start">
                        <CheckCircleFilled
                          style={{ color: token.colorPrimary, marginTop: 3 }}
                        />
                        <Text>{item}</Text>
                      </Flex>
                    ))}
                  </Flex>
                </Card>
              </Flex>
            </Col>
          </Row>
        </Content>
      </Layout>
    )
  }

  return children
}
